module.exports = __webpack_public_path__ + "static/media/recycleImage.ececc489.svg";